Attachment = require 'app/scripts/models/attachment'
CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
Dates = require 'app/scripts/lib/dates'

class AttachmentList extends CollectionWithHelpers
  model: Attachment

  initialize: (models, options) ->
    @listenTo @, 'change:pos', @sort

  comparator: (attachment) ->
    attachment.get('pos') || (Dates.parse(attachment.get('date')))

module.exports = AttachmentList
